import { EnvPill } from "@/components/iris";
import type { Env } from "@/lib/types";
import { useState } from "react";
import { UsersPage } from "./users-page";

export function EnvUsersPage() {
  const [env, setEnv] = useState<Env>("prod");

  return (
    <div className="iris-page">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <h1 className="iris-page__title" style={{ fontSize: 32, margin: 0 }}>
          User Management
        </h1>
        <EnvPill value={env} onChange={setEnv} />
      </div>
      <UsersPage env={env} />
    </div>
  );
}
